import React from 'react'
import styled from 'styled-components/macro'
import {
  SearchBar,
  SearchIcon,
  SearchInput,
  SearchInputContainer,
} from 'src/components/Reusable/Search/Search.styles'

const Wrapper = styled.div`
  padding: 8px 12px;

  ${SearchBar} {
    width: 100%;
  }
`

type DropdownSearchInputProps = {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  autoFocus?: boolean
  onClick?: (e: React.MouseEvent<HTMLInputElement>) => void
}

export const DropdownSearchInput = ({
  value,
  onChange,
  placeholder = 'Search',
  autoFocus,
  onClick,
}: DropdownSearchInputProps): JSX.Element => (
  <Wrapper>
    <SearchBar>
      <SearchInputContainer>
        <SearchIcon />
        <SearchInput
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onClick={onClick}
          placeholder={placeholder}
          autoFocus={autoFocus}
        />
      </SearchInputContainer>
    </SearchBar>
  </Wrapper>
)
